import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TrapType } from '@/components/game/traps/Trap';

interface TrapState {
  availableTraps: Record<TrapType, number>;
  selectedTrapType: TrapType | null;
  isPlacingTrap: boolean;
  maxTrapsPerType: number;
  placedTraps: Record<TrapType, number>;
}

const initialState: TrapState = {
  availableTraps: {
    [TrapType.SPIKE]: 5,
    [TrapType.FIRE]: 3,
    [TrapType.ICE]: 2,
    [TrapType.POISON]: 1
  },
  selectedTrapType: null,
  isPlacingTrap: false,
  maxTrapsPerType: 20,
  placedTraps: {
    [TrapType.SPIKE]: 0,
    [TrapType.FIRE]: 0,
    [TrapType.ICE]: 0,
    [TrapType.POISON]: 0
  }
};

export const trapSlice = createSlice({
  name: 'trap',
  initialState,
  reducers: {
    selectTrapType: (state, action: PayloadAction<TrapType | null>) => {
      state.selectedTrapType = action.payload;
      state.isPlacingTrap = action.payload !== null;
    },
    
    setIsPlacingTrap: (state, action: PayloadAction<boolean>) => {
      state.isPlacingTrap = action.payload;
      if (!action.payload) {
        state.selectedTrapType = null;
      }
    },
    
    addTrap: (state, action: PayloadAction<TrapType>) => {
      const trapType = action.payload;
      if (state.availableTraps[trapType] > 0) {
        state.availableTraps[trapType]--;
      }
    },
    
    placeTrap: (state, action: PayloadAction<TrapType>) => {
      const trapType = action.payload;
      state.placedTraps[trapType]++;
    },
    
    removeTrap: (state, action: PayloadAction<TrapType>) => {
      const trapType = action.payload;
      if (state.placedTraps[trapType] > 0) {
        state.placedTraps[trapType]--;
      }
    },
    
    setAvailableTraps: (state, action: PayloadAction<Record<TrapType, number>>) => {
      state.availableTraps = action.payload;
    },
    
    addAvailableTrap: (state, action: PayloadAction<{type: TrapType, count: number}>) => {
      const { type, count } = action.payload;
      state.availableTraps[type] += count;
    },
    
    setMaxTrapsPerType: (state, action: PayloadAction<number>) => {
      state.maxTrapsPerType = action.payload;
    },
    
    resetTrapState: (state) => {
      return initialState;
    }
  }
});

export const {
  selectTrapType,
  setIsPlacingTrap,
  addTrap,
  placeTrap,
  removeTrap,
  setAvailableTraps,
  addAvailableTrap,
  setMaxTrapsPerType,
  resetTrapState
} = trapSlice.actions;

export default trapSlice.reducer; 